import Vue from 'vue'
import Router from 'vue-router'
const index = () => import('@/components/index')
const app = () => import('@/components/app/index')
const guanyu = () => import('@/components/guanyu/index')
const contact = () => import('@/components/guanyu/contact')
const contactapp = () => import('@/components/guanyu/contact_app')
const disclaimer = () => import('@/components/guanyu/disclaimer')
const disclaimerapp = () => import('@/components/guanyu/disclaimer_app')
const map = () => import('@/components/guanyu/map')
// const news = () => import('@/components/news/index')
const news = () => import('@/views/NewsList')
// const detail = () => import('@/components/news/detail')
const detail = () => import('@/views/NewsDetail')
const shuju = () => import('@/components/shuju/index')
const tuijian = () => import('@/components/tuijian/index')
const footballAnalyst = () => import('@/components/tuijian/football-analyst')
const dashenbang = () => import('@/components/tuijian/dashenbang')
const analystTalk = () => import('@/components/tuijian/analyst-talk')
const zuqiu = () => import('@/components/zuqiu/index')
const live = () => import('@/components/zuqiu/live')
const gameteams = () => import('@/components/zuqiu/gameteams')
const shujufenxi = () => import('@/components/zuqiu/shujufenxi')
const changeDetail = () => import('@/components/zuqiu/changeDetail')
const wanchang = () => import('@/components/zuqiu/wanchang')
const saicheng = () => import('@/components/zuqiu/saicheng')
const lanqiu = () => import('@/components/lanqiu/index')
const llive = () => import('@/components/lanqiu/live')
const lgameteams = () => import('@/components/lanqiu/gameteams')
const lshujufenxi = () => import('@/components/lanqiu/shujufenxi')
const lchangeDetail = () => import('@/components/lanqiu/changeDetail')
const lwanchang = () => import('@/components/lanqiu/wanchang')
const lsaicheng = () => import('@/components/lanqiu/saicheng')
const recommend = () => import('@/components/recommend/index')
const past = () => import('@/components/recommend/past')
const zonghe = () => import('@/components/zonghe/index')
const zlive = () => import('@/components/zonghe/live')
const dianjing = () => import('@/components/dianjing/index')
const dsaicheng = () => import('@/components/dianjing/saicheng')
const dlive = () => import('@/components/dianjing/live')
const protocol = () => import('@/components/loading/protocol')
const anchorProtocol = () => import('@/components/loading/anchorProtocol')
const exit = () => import('@/components/exit/index')
const gaming = () => import('@/views/gaming/index')
const gamingLive = () => import('@/views/gaming/live')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/exit',
      name: 'exit',
      component: exit
    },
    {
      path: '/app',
      name: 'app',
      component: app
    },
    {
      path: '/guanyu',
      name: 'guanyu',
      component: guanyu
    },
    {
      path: '/guanyu/contact',
      name: 'contact',
      component: contact
    },
    {
      path: '/ios/contact',
      name: 'contactapp',
      component: contactapp
    },
    {
      path: '/guanyu/disclaimer',
      name: 'disclaimer',
      component: disclaimer
    },
    {
      path: '/ios/disclaimer',
      name: 'disclaimerapp',
      component: disclaimerapp
    },
    {
      path: '/guanyu/map',
      name: 'map',
      component: map
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/news/:navid',
      name: 'sub_news',
      component: news
    },
    {
      path: '/news/detail/:id',
      name: 'detail',
      component: detail
    },
    {
      path: '/tuijian',
      name: 'tuijian',
      component: tuijian
    },
    {
      path: '/tuijian/football-analyst',
      name: 'footballAnalyst',
      component: footballAnalyst
    },
    {
      path: '/tuijian/dashenbang',
      name: 'dashenbang',
      component: dashenbang
    },
    {
      path: '/tuijian/analyst-talk',
      name: 'analystTalk',
      component: analystTalk
    },
    {
      path: '/zuqiu',
      name: 'zuqiu',
      component: zuqiu
    },
    {
      path: '/zuqiu/live',
      name: 'live',
      component: live
    },
    {
      path: '/zuqiu/gameteams',
      name: 'gameteams',
      component: gameteams
    },
    {
      path: '/zuqiu/shujufenxi',
      name: 'shujufenxi',
      component: shujufenxi
    },
    {
      path: '/zuqiu/changeDetail',
      name: 'changeDetail',
      component: changeDetail
    },
    {
      path: '/zuqiu/wanchang',
      name: 'wanchang',
      component: wanchang
    },
    {
      path: '/zuqiu/saicheng',
      name: 'saicheng',
      component: saicheng
    },
    {
      path: '/lanqiu',
      name: 'lanqiu',
      component: lanqiu
    },
    {
      path: '/lanqiu/live',
      name: 'llive',
      component: llive
    },
    {
      path: '/lanqiu/gameteams',
      name: 'lgameteams',
      component: lgameteams
    },
    {
      path: '/lanqiu/shujufenxi',
      name: 'lshujufenxi',
      component: lshujufenxi
    },
    {
      path: '/lanqiu/changeDetail',
      name: 'lchangeDetail',
      component: lchangeDetail
    },
    {
      path: '/lanqiu/wanchang',
      name: 'lwanchang',
      component: lwanchang
    },
    {
      path: '/lanqiu/saicheng',
      name: 'lsaicheng',
      component: lsaicheng
    },
    {
      path: '/zonghe/recommend',
      name: 'recommend',
      component: recommend
    },
    {
      path: '/zonghe/recommend/past/:id',
      name: 'past',
      component: past
    },
    {
      path: '/zonghe/live',
      name: 'zlive',
      component: zlive
    },
    {
      path: '/zonghe',
      name: 'zonghe',
      component: zonghe
    },
    {
      path: '/zonghe/:type',
      name: 'zonghe_type',
      component: zonghe
    },
    {
      path: '/dianjing',
      name: 'dianjing',
      component: dianjing
    },
    {
      path: '/dianjing/saicheng',
      name: 'dsaicheng',
      component: dsaicheng
    },
    {
      path: '/dianjing/live',
      name: 'dlive',
      component: dlive
    },
    // 电竞 router start
    // 暂时限定四款电竞游戏
    {
      path: '/gaming/:type(dota2|lol|csgo|kog)',
      name: 'gaming',
      component: gaming
    },
    // 赛果
    {
      path: '/gaming/completed/:type(dota2|lol|csgo|kog)',
      name: 'completed',
      component: gaming
    },
    // 赛程
    {
      path: '/gaming/schedule/:type(dota2|lol|csgo|kog)',
      name: 'schedule',
      component: gaming
    },
    // 收藏的赛事
    {
      path: '/gaming/collect/:type(dota2|lol|csgo|kog)',
      name: 'collect',
      component: gaming
    },
    {
      path: '/live/:type(dota2|lol|csgo|kog)',
      name: 'live-detail',
      component: gamingLive
    },
    // 电竞 router end
    {
      path: '/protocol',
      name: 'protocol',
      component: protocol
    },
    {
      path: '/anchorProtocol',
      name: 'anchorProtocol',
      component: anchorProtocol
    },
    {
      path: '/shuju/:type',
      name: 'shuju',
      component: shuju
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

// router.beforeEach((to, from, next) => {
//   const urls = JSON.parse(localStorage.getItem('Locations') || "[]")
//   urls.push(location.href)
//   localStorage.setItem('Locations', JSON.stringify(urls))
//   next()
// })

export default router